import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Grid,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    InputAdornment,
    IconButton,
    FormHelperText,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox,
    Divider,
    FormLabel
} from '@mui/material';
import { CloudUpload, LinkedIn, Twitter, YouTube } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import swal from 'sweetalert';
import { useHistory } from "react-router-dom";
import ConferenceNavbar from "../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from './AbstractAuth/NewVersion/NewVersionAnstractFooter';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const SpeakerRegistrationForm = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
    const [currentDateTime, setCurrentDateTime] = useState(new Date().toISOString());
    const [formData, setFormData] = useState({
        eventid: '',
        name_title: 'Mr',
         gender: "1",
        speaker_name: '',
        email: '',
        password: '',
        phone_number: '',
        profession: '',
        organization: '',
        country: '',
        city: '',
        biography: '',
        spkeakerProfilephoto: null,
        video: null,
        company_name: '',
        company_logo: null,
        website: '',
        linkedin: '',
        twitter: '',
        youtube: '',
        nationality: '',
        passport_number: '',
        passport_expiry: '',
        needs_accommodation: 0,
        needs_invitation_letter: 0,
        conference_category_id: '',


        // ASP (Hospital) fields
        hospital_name: '',
        region_city: '',
        bed_capacity: '',

        contact_name: '',
        contact_position: '',
        contact_email: '',
        contact_phone: '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files[0]
        }));

        // Clear file error when user selects a file
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    useEffect(() => {
        axios.get(`api/conference-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const ccategoryData = res.data.conferenceCategories;
                const currentDateTime = res.data.currentDateTime;

                setConferenceCategoryData(ccategoryData);
                setCurrentDateTime(currentDateTime);
            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setErrors({});

        const fullFormData = {
            ...formData,
            eventid: eventid || '',
            photo: formData.spkeakerProfilephoto // Map to the expected field name
        };

        const formDataToSend = new FormData();

        Object.keys(fullFormData).forEach(key => {
            const value = fullFormData[key];
            if (value !== null && value !== undefined && value !== '') {
                formDataToSend.append(key, value);
            }
        });

        try {
            await axios.get('/sanctum/csrf-cookie');

            const response = await axios.post(
                `/api/conference-speaker-registration`,
                formDataToSend,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (response.data.status === 200) {
                const participantId = response.data.participant_id;
                swal({
                    title: "Registration Successful",
                    text: response.data.message,
                    icon: "success",
                    button: "OK",
                });
                history.push({
                    pathname: `/conference/speaker-thank-you/${participantId}`,
                });
            } else {
                setErrors(response.data.errors || {});
            }
        } catch (error) {
            console.error('Registration error:', error);
            if (error.response) {
                setErrors(error.response.data.errors || {});
                swal('Error', 'Please fix the errors in the form', 'error');
            } else {
                setErrors({ general: 'An error occurred. Please try again.' });
                swal('Error', 'An error occurred. Please try again.', 'error');
            }
        } finally {
            setSubmitting(false);
        }
    };
    const staticChange = eventid == 68;
    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>
            <Box sx={{ maxWidth: 800, mx: 'auto', my: 4 }}>

                {staticChange ? (
                    <>
                        {/* Title */}
                        <Typography
                            variant="h4"
                            component="h1"
                            gutterBottom
                            align="center"
                            sx={{ fontWeight: "bold", mb: 3 }}>
                            Online Application Form
                        </Typography>

                        <form onSubmit={handleSubmit}>
                            {/* Hospital Information */}
                            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "primary.main" }}>
                                Hospital Information
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Hospital Name"
                                        name="company_name"
                                        value={formData.company_name || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Sector: Private or Government "
                                        name="nationality"
                                        value={formData.nationality || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Services ( Inpatient, Outpatient, Long stay facility, or All)"
                                        name="organization"
                                        value={formData.organization || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Region / City"
                                        name="city"
                                        value={formData.city || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Bed Capacity (Total/ICU/NICU)"
                                        name="passport_number"
                                        value={formData.passport_number || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={4}
                                        label="Applicant Name who represent the institution and his/her Emai"
                                        name="biography"
                                        value={formData.biography || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                                        Is your antimicrobial stewardship program activity involved in national programs and initiatives
                                        (i.e. submitting KPI's, participate in awareness campaigns, reporting to PHA)?
                                    </Typography>

                                    <FormControl fullWidth error={!!errors.needs_accommodation}>
                                        {/* <InputLabel>Need Accommodation?</InputLabel> */}
                                        <Select
                                            name="needs_accommodation"
                                            value={formData.needs_accommodation}
                                            onChange={handleChange}
                                        //label="Need Accommodation?"
                                        >
                                            <MenuItem value={1}>Yes</MenuItem>
                                            <MenuItem value={0}>No</MenuItem>
                                        </Select>
                                        {errors.needs_accommodation && (
                                            <FormHelperText>{errors.needs_accommodation[0]}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>


                            </Grid>


                            {/* Contact Person */}
                            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: "primary.main" }}>
                                Contact Person
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth error={!!errors.name_title}>
                                        <InputLabel>Title</InputLabel>
                                        <Select
                                            name="name_title"
                                            value={formData.name_title}
                                            onChange={handleChange}
                                            label="Title"
                                        >
                                            <MenuItem value="Mr">Mr</MenuItem>
                                            <MenuItem value="Mrs">Mrs</MenuItem>
                                            <MenuItem value="Dr">Dr</MenuItem>
                                            <MenuItem value="Prof">Prof</MenuItem>
                                        </Select>
                                        {errors.name_title && <FormHelperText>{errors.name_title[0]}</FormHelperText>}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Full Name"
                                        name="speaker_name"
                                        value={formData.speaker_name || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Position"
                                        name="profession"
                                        value={formData.profession || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Email"
                                        name="email"
                                        value={formData.email || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Phone"
                                        name="phone_number"
                                        value={formData.phone_number || ""}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Password"
                                        name="password"
                                        type="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.password}
                                        helperText={errors.password && errors.password[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Gender</FormLabel>
                                        <RadioGroup
                                            row
                                            name="gender"
                                            value={formData.gender}
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label="Male" />
                                            <FormControlLabel value="0" control={<Radio />} label="Female" />
                                        </RadioGroup>
                                        {errors.gender && (
                                            <FormHelperText error>{errors.gender[0]}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                            </Grid>

                            {/* Declaration */}
                            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: "primary.main" }}>
                                Declaration
                            </Typography>
                            <FormControl>
                                <label>
                                    <input
                                        type="checkbox"
                                        name="declaration"
                                        checked={formData.declaration || false}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                declaration: e.target.checked,
                                            }))
                                        }
                                    />{" "}
                                    I confirm that all provided information is accurate and approved by hospital
                                    administration.
                                </label>
                            </FormControl>

                            {/* Submit Button */}
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    sx={{ px: 6, py: 1.5 }}
                                    disabled={submitting}
                                >
                                    {submitting ? "Submitting..." : "Submit Application"}
                                </Button>
                            </Box>
                        </form>
                    </>
                ) : (<>
                    <Paper elevation={3} sx={{ p: 4 }}>
                        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold', mb: 3 }}>
                            Speaker / Member Registration
                        </Typography>

                        {errors.general && (
                            <Typography color="error" sx={{ mb: 2 }}>
                                {errors.general}
                            </Typography>
                        )}

                        <form onSubmit={handleSubmit}>
                            {/* Personal Information */}
                            <Typography variant="h6" sx={{ mt: 3, mb: 2, color: 'primary.main' }}>
                                Personal Information
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth error={!!errors.name_title}>
                                        <InputLabel>Title</InputLabel>
                                        <Select
                                            name="name_title"
                                            value={formData.name_title}
                                            onChange={handleChange}
                                            label="Title"
                                        >
                                            <MenuItem value="Mr">Mr</MenuItem>
                                            <MenuItem value="Mrs">Mrs</MenuItem>
                                            <MenuItem value="Dr">Dr</MenuItem>
                                            <MenuItem value="Prof">Prof</MenuItem>
                                        </Select>
                                        {errors.name_title && <FormHelperText>{errors.name_title[0]}</FormHelperText>}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Full Name"
                                        name="speaker_name"
                                        value={formData.speaker_name}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.speaker_name}
                                        helperText={errors.speaker_name && errors.speaker_name[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.email}
                                        helperText={errors.email && errors.email[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Password"
                                        name="password"
                                        type="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.password}
                                        helperText={errors.password && errors.password[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Phone Number"
                                        name="phone_number"
                                        value={formData.phone_number}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.phone_number}
                                        helperText={errors.phone_number && errors.phone_number[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Profession"
                                        name="profession"
                                        value={formData.profession}
                                        onChange={handleChange}
                                        error={!!errors.profession}
                                        helperText={errors.profession && errors.profession[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6} sm={12}>
                                    <FormControl fullWidth error={!!errors.conference_category_id}>
                                        <InputLabel id="category-label">Conference Category</InputLabel>
                                        <Select
                                            name="conference_category_id"
                                            value={formData.conference_category_id}
                                            onChange={handleChange}
                                            labelId="category-label"
                                            id="category-select"
                                            label="Conference Category"
                                        >
                                            {conferenceCategoryData && conferenceCategoryData.map(val => (
                                                <MenuItem key={val.id} value={val.id}>
                                                    {val.conference_category_title}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.conference_category_id && <FormHelperText>{errors.conference_category_id[0]}</FormHelperText>}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6} sm={12}>
                                    <TextField
                                        fullWidth
                                        label="Organization"
                                        name="organization"
                                        value={formData.organization}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.organization}
                                        helperText={errors.organization && errors.organization[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Country"
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.country}
                                        helperText={errors.country && errors.country[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="City"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.city}
                                        helperText={errors.city && errors.city[0]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Biography"
                                        name="biography"
                                        value={formData.biography}
                                        onChange={handleChange}
                                        required
                                        multiline
                                        rows={4}
                                        error={!!errors.biography}
                                        helperText={errors.biography && errors.biography[0]}
                                    />
                                </Grid>
                            </Grid>

                            {/* Photo and Video Upload */}
                            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                                Media Uploads
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        startIcon={<CloudUpload />}
                                        fullWidth
                                        sx={{ py: 2 }}
                                        error={!!errors.photo}
                                    >
                                        Upload Speaker Photo
                                        <VisuallyHiddenInput
                                            type="file"
                                            name="spkeakerProfilephoto"
                                            onChange={handleFileChange}
                                            accept="image/*"
                                        />
                                    </Button>
                                    {errors.photo && (
                                        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                                            {errors.photo[0]}
                                        </Typography>
                                    )}
                                    {formData.spkeakerProfilephoto && (
                                        <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                                            Selected: {formData.spkeakerProfilephoto.name}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>

                            {/* Company Information */}
                            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                                Company Information
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Company Name"
                                        name="company_name"
                                        value={formData.company_name}
                                        onChange={handleChange}
                                        error={!!errors.company_name}
                                        helperText={errors.company_name && errors.company_name[0]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        startIcon={<CloudUpload />}
                                        fullWidth
                                        sx={{ py: 2 }}
                                        error={!!errors.company_logo}
                                    >
                                        Upload Company Logo
                                        <VisuallyHiddenInput
                                            type="file"
                                            name="company_logo"
                                            onChange={handleFileChange}
                                            accept="image/*"
                                        />
                                    </Button>
                                    {errors.company_logo && (
                                        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                                            {errors.company_logo[0]}
                                        </Typography>
                                    )}
                                    {formData.company_logo && (
                                        <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                                            Selected: {formData.company_logo.name}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Website"
                                        name="website"
                                        value={formData.website}
                                        onChange={handleChange}
                                        error={!!errors.website}
                                        helperText={errors.website && errors.website[0]}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    https://
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            {/* Social Media */}
                            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                                Social Media Profiles
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="LinkedIn"
                                        name="linkedin"
                                        value={formData.linkedin}
                                        onChange={handleChange}
                                        error={!!errors.linkedin}
                                        helperText={errors.linkedin && errors.linkedin[0]}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LinkedIn color="primary" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Twitter/X"
                                        name="twitter"
                                        value={formData.twitter}
                                        onChange={handleChange}
                                        error={!!errors.twitter}
                                        helperText={errors.twitter && errors.twitter[0]}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Twitter color="primary" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="YouTube"
                                        name="youtube"
                                        value={formData.youtube}
                                        onChange={handleChange}
                                        error={!!errors.youtube}
                                        helperText={errors.youtube && errors.youtube[0]}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <YouTube color="error" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            {/* Travel Information */}
                            <Typography variant="h6" sx={{ mt: 4, mb: 2, color: 'primary.main' }}>
                                Travel Information
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Nationality"
                                        name="nationality"
                                        value={formData.nationality}
                                        onChange={handleChange}
                                        required
                                        error={!!errors.nationality}
                                        helperText={errors.nationality && errors.nationality[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Passport Number"
                                        name="passport_number"
                                        value={formData.passport_number}
                                        onChange={handleChange}
                                        error={!!errors.passport_number}
                                        helperText={errors.passport_number && errors.passport_number[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        label="Passport Expiry (MM-DD-YYYY)"
                                        name="passport_expiry"
                                        value={formData.passport_expiry}
                                        onChange={handleChange}
                                        placeholder="YYYY-MM-DD"
                                        error={!!errors.passport_expiry}
                                        helperText={errors.passport_expiry && errors.passport_expiry[0]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth error={!!errors.needs_accommodation}>
                                        <InputLabel>Need Accommodation?</InputLabel>
                                        <Select
                                            name="needs_accommodation"
                                            value={formData.needs_accommodation}
                                            onChange={handleChange}
                                            label="Need Accommodation?"
                                        >
                                            <MenuItem value={1}>Yes</MenuItem>
                                            <MenuItem value={0}>No</MenuItem>
                                        </Select>
                                        {errors.needs_accommodation && <FormHelperText>{errors.needs_accommodation[0]}</FormHelperText>}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth error={!!errors.needs_invitation_letter}>
                                        <InputLabel>Need Invitation Letter?</InputLabel>
                                        <Select
                                            name="needs_invitation_letter"
                                            value={formData.needs_invitation_letter}
                                            onChange={handleChange}
                                            label="Need Invitation Letter?"
                                        >
                                            <MenuItem value={1}>Yes</MenuItem>
                                            <MenuItem value={0}>No</MenuItem>
                                        </Select>
                                        {errors.needs_invitation_letter && <FormHelperText>{errors.needs_invitation_letter[0]}</FormHelperText>}
                                    </FormControl>
                                </Grid>
                            </Grid>

                            {/* Submit Button */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    sx={{ px: 6, py: 1.5 }}
                                    disabled={submitting}
                                >
                                    {submitting ? 'Registering...' : 'Register as Speaker'}
                                </Button>
                            </Box>
                        </form>
                    </Paper>
                </>)}

            </Box>
            <NewVersionAbstractFooter />
        </div>
    );
};

export default SpeakerRegistrationForm;